<script setup>
import { computed } from 'vue'

/**
 * The component's inherited properties.
 */
const props = defineProps({
    /**
     * The given value.
     *
     * @type {Object}
     */
    value: {
        type: Object,
        required: true,
    },
})

/**
 * Get the load's miles.
 *
 * @return {Number}
 */
const miles = computed(() => {
    return Math.round(props.value?.total_miles).toLocaleString() || 0
})

/**
 * Get the load's stops.
 *
 * @return {Number}
 */
const stops = computed(() => {
    return props.value?.stops || 0
})
</script>

<template>
    <div class="flex justify-between items-center">
        <div class="flex items-center">
            <span data-test="from-to-start">
                {{ value?.start }}
            </span>
            <v-chip
                color="primary"
                class="ms-2 text-base"
                size="x-small"
                data-test="from-to-stops-miles"
            >
                {{ stops }} stops · {{ miles }} miles.
            </v-chip>
        </div>
        <div class="grow border-b border-[#6c6c6c] relative mx-2">
            <v-icon
                size="x-small"
                icon="fat fa-chevron-right"
                class="absolute"
                color="#6c6c6c"
                style="right: -3px; top: -6px"
            />
        </div>
        <div data-test="from-to-end">
            {{ value?.end }}
        </div>
    </div>
</template>
